import { CompleteUser, User } from '../types';

export const parseUser = (user: CompleteUser): User => {
	return {
		enableEmailNotifications: user.enableEmailNotifications,
		email: user.email,
		emailAddresses: user.emailAddresses,
		name: user.name,
		firstName: user.firstName,
		surname: user.surname,
		permissions: user.activePermissions,
		roles: user.activeRoles.map(role => role.role.key),
		_id: user._id,
		createdByControl: user.createdByControl,
		company: user.company,
		jobTitle: user.jobTitle,
		profileImage: user.profileImage,
		phoneNumber: user.phoneNumber,
		entities: user.entities,
		recruiterModeEnabled: user.recruiterModeEnabled,
		onboardingProgress: user.onboardingProgress,
		widgets: user.widgets,
	};
};
